import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';

import { BaseService } from '../base/base.service';
import { Query } from '../../models/query/query';
import { AppModulePath } from '../../models/app-module-path';

import { DocumentAddress } from 'app/models/lookups/DocumentAddress';
import { Address } from 'app/models/lookups/address';

@Injectable()
export class AddressService extends BaseService {

  private listUrl = '/api/address/listWithCity';

  constructor(
    protected injector: Injector,
    protected http2: HttpClient,
    protected platformLocation: PlatformLocation
  ) {
    super(injector, http2, platformLocation);
  }


  list(qry: Query): Observable<DocumentAddress[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<DocumentAddress[]>(
      url,
      AppModulePath.DOCUMENT
    ).pipe(
      map(res => res.map(obj => new DocumentAddress(obj))),
      catchError(this.handleError)
    );
  }

}
